export const MIN_SELECT_OPTIONS = 20;
export const specialCharactersError =
  "This field cannot contain special character";
